/* eslint-disable no-undef */

import React, {useCallback, useEffect} from 'react';
import {Row, Button, Alert} from 'reactstrap';
import Field from '../../components/Field.js';
import Loader from '../../components/Loader/Loader';
import useTransaction from '../../../hooks/useTransaction.js';
import ccImg from '../../../assets/cc.png';
import visaImg from '../../../assets/visa.png';
import mastercardImg from '../../../assets/mastercard.png';
import amexImg from '../../../assets/amex.png';
import ccLogo from '../../../assets/pci-logo.png';

const creditCard = ({route = 'default', showBack = true}) => {
	const transaction = useTransaction(route);

	const listenPostMessage = useCallback(event => {
		if (event.data.action !== 'init') {
			return;
		}

		const sum = event.data.payload?.sum;
		if (sum) {
			transaction.setPaymentAmount(sum);
		}

		const email = event.data.payload?.email;
		if (email) {
			transaction.setPaymentEmail(email);
		}
	});

	useEffect(() => {
		document.querySelectorAll('body')[0]
			.classList.add(`route-${route}`);
	});

	useEffect(() => {
		window.addEventListener('message', listenPostMessage);
		return () => {
			window.removeEventListener('message', listenPostMessage);
		};
	}, [listenPostMessage]);

	const setCardImage = mutag => {
		switch (mutag) {
			case '2': {
				return visaImg;
			}

			case '4': {
				return amexImg;
			}

			case '7': {
				return mastercardImg;
			}

			default: {
				return ccImg;
			}
		}
	};

	return (
		<form className='container' onSubmit={transaction.onSubmit}>
			{transaction.errMsg && <Row><Alert className='col-12' color='danger'>{transaction.errMsg}</Alert></Row>}
			{(transaction.PCode && !transaction.pciSuccess) ? (
				<>
					<Row className='inputs-wrapper'>
						{Object.keys(transaction.fields).map((name, ind) => (
							<Field
								key={ind}
								name={name}
								setValue={transaction.setValue}
								value={transaction.watch()[name]}
								errors={transaction.errors}
								trigger={transaction.trigger}
								disabled={Boolean(transaction.LineCC)}
								{...transaction.fields[name]}
							/>
						),
						)}
					</Row>
					{
						Array.isArray(transaction.CCCardData) && transaction.CCCardData.length > 0 ? (
							<div className='inputs-wrapper mt-1 mb-2 saved-cc'>
								<h5 className='mb-3 mt-1 saved-cards-title'>כרטיסים שמורים ללקוח:</h5>
								{
									transaction.CCCardData.map(({First6or2, Last4, Line, Mutag = null}, i) => (
										<div key={i} className='mb-2 saved-cards-web'>
											<Button
												color={`light${transaction.LineCC === Line ? ' active' : ''}`}
												dir='ltr'
												className='saved-card-button col-12 col-md-4'
												onClick={() => transaction.selectCC(Line)}
											>
												{First6or2} XXXX XXXX {Last4}<img src={setCardImage(Mutag)} alt=''/>
											</Button>
											<div className='form-check' onClick={() => transaction.selectCC(Line)}>
												<input readOnly checked={transaction.LineCC === Line} className='form-check-input' type='radio' name='flexRadioDefault' id='flexRadioDefault1'/>
												<label><div className={transaction.LineCC === Line ? 'circle-web' : 'd-none'}/></label>
											</div>
										</div>
									))
								}
							</div>
						) : null
					}
					<div className='d-flex justify-content-between mt-4 button-cc-wrapper'>
						{
							(showBack && transaction.stepBack) && <Button
								disabled={transaction.loading}
								color='outline-primary'
								className='px-3 py-1 button-web gamapay-field-button'
								onClick={() => transaction.stepBack()}>
								<span>‹&nbsp;&nbsp;&nbsp;חזרה אחורה</span>
							</Button>
						}
						<div className='next-button-wrapper'>
							{}
							<Button
								disabled={transaction.loading}
								color='warning'
								className='text-primary px-3 py-1 button-web gamapay-field-button gamapay-field-button-submit'
							>
								{transaction.loading ? 'טוען...' : <span>לביצוע חיוב&nbsp;&nbsp;&nbsp;›</span>}
							</Button>
						</div>
					</div>
					<div className='confirm-text mt-5'>
						על ידי לחיצה על כפתור "תשלום" הנני  מאשר/ת התנאים הכתובים בהודעה זו.<br/>
						אני מאשר/ת כי פרטי העסקה כפי שהם רשומים בהודעה זו - נכונים.<br/>
						ידוע לי כי ביטול עסקה יהיה כפוף להוראות חוק שירותי תשלום ה'תשע"ט-2019.<br/>
					</div>
				</>
			) : <Loader/>}
			<div className='bottom-logo'>
				<div className='d-static d-sm-flex justify-content-between'>
					<div>
						<div className='mb-1'>מערכת סליקת האשראי עומדת בתקן אבטחה PCI DSS Level 1</div>
						<div>ומוגנת בפרוטוקול TLS לתקשורת מוצפנת ומאובטחת</div>
					</div>
					<div className='logo-group'>
						<a title='לוגו גמא' className='gama-logo' href='https://gamaf.co.il' target='_blank' rel='noreferrer'>
							<img src={ccLogo} alt='לוגו גמא'/>
						</a>
					</div>
				</div>
			</div>
		</form>
	);
};

export default creditCard;
